export type WebDebugState = {
  colorReport?: {
    applied: number;
    missing: number;
    invalid: number;
  };
  lastError?: string;
  modelPath?: string;
  modelJsonName?: string;
  expressionsConfigured?: string;
  state?: string;
  texturesLoaded?: number;
  textureTotal?: number;
};

declare global {
  interface Window {
    __OPENVT_HEADPATS_DEBUG__?: WebDebugState;
  }
}

export function setDebugState(update: WebDebugState): void {
  window.__OPENVT_HEADPATS_DEBUG__ = {
    ...(window.__OPENVT_HEADPATS_DEBUG__ ?? {}),
    ...update,
  };

  const state = window.__OPENVT_HEADPATS_DEBUG__;
  const dataset = document.documentElement.dataset;
  if (state.state) {
    dataset.openvtState = state.state;
  }
  if (state.modelPath) {
    dataset.openvtModelPath = state.modelPath;
  }
  if (state.modelJsonName) {
    dataset.openvtModelJsonName = state.modelJsonName;
  }
  if (state.expressionsConfigured) {
    dataset.openvtExpressionsConfigured = state.expressionsConfigured;
  }
  if (state.colorReport) {
    dataset.openvtColorsApplied = state.colorReport.applied.toString();
    dataset.openvtColorsMissing = state.colorReport.missing.toString();
    dataset.openvtColorsInvalid = state.colorReport.invalid.toString();
  }
  if (state.texturesLoaded != null) {
    dataset.openvtTexturesLoaded = state.texturesLoaded.toString();
  }
  if (state.textureTotal != null) {
    dataset.openvtTextureTotal = state.textureTotal.toString();
  }
}
